mutation leadAiSummary($input: LeadAiSummaryInput!) {
    leadAiSummary(input: $input) {
        summary
        generatedAt
    }
}
